function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
import React from "react";
export var IconCheckmark = function IconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _object_spread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100",
    height: "96",
    viewBox: "0 0 100 96",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M93.4933 51.5116C91.6958 74.9811 72.0756 93.4737 48.1009 93.4737C22.9363 93.4737 2.53125 73.1116 2.53125 48C2.53125 22.8885 22.9363 2.52637 48.1009 2.52637C55.9237 2.52637 63.2907 4.49689 69.7464 7.98321",
    stroke: "currentColor",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1133 44.2107L48.1006 63.1581L97.4677 10.1055",
    stroke: "currentColor",
    strokeWidth: "3",
    strokeLinecap: "round"
  }));
};